import * as React from 'react';

import SkillSetCompletionBanner from 'bundles/program-home/components/SkillSetCompletionBanner';
import type { TargetSkillProfileUserStatesQuery_TargetSkillProfileUserStatesV1Resource_byUserAndProgram_elements as UserSkillProfileStateType } from 'bundles/program-home/components/__generated__/TargetSkillProfileUserStatesQuery';

type PropsFromCaller = {
  completedSkillSets?: UserSkillProfileStateType[];
  programSlug: string;
};

const SkillSetCompletionBannerList: React.FC<PropsFromCaller> = ({ programSlug, completedSkillSets }) => {
  if (!completedSkillSets?.length) {
    return null;
  }

  return (
    <div>
      {completedSkillSets.map((userSkillProfile) => {
        const tspTitle = userSkillProfile.targetSkillProfile?.title;
        const objectiveSlug = userSkillProfile.targetSkillProfile?.slug;
        return tspTitle && objectiveSlug ? (
          <SkillSetCompletionBanner
            key={userSkillProfile.id}
            skillSetName={tspTitle}
            programSlug={programSlug}
            objectiveSlug={objectiveSlug}
          />
        ) : null;
      })}
    </div>
  );
};

export default SkillSetCompletionBannerList;
